"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _usageTrackerPublic = require("usage-tracker-public");

var _commonTrackerProperties = _interopRequireDefault(require("./commonTrackerProperties"));

var _default = (0, _usageTrackerPublic.createTracker)((0, _commonTrackerProperties.default)(true));

exports.default = _default;
module.exports = exports.default;